/*
 *
 * RateLimitsV2 constants
 *
 */
import React from 'react';

import moment from 'moment';
import { Space, Text, Popup, Icon } from '@cashfree-intl/coherent';
import CustomIcons from 'components/CustomIcons';

export const BASE_ACTION_CONSTANT = 'app/RateLimitsV2';

export const FETCH_RATE_LIMIT_METRICS = `${BASE_ACTION_CONSTANT}/FETCH_RATE_LIMIT_METRICS`;

export const FETCH_RATE_LIMIT_GRAPH_DATA = `${BASE_ACTION_CONSTANT}/FETCH_RATE_LIMIT_GRAPH_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const UPDATE_RATE_LIMIT_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_RATE_LIMIT_TABLE_DATA`;

export const ADD_REQUEST_FOR_UPDATING_RATE_LIMIT = `${BASE_ACTION_CONSTANT}/ADD_REQUEST_FOR_UPDATING_RATE_LIMIT`;

export const CANCEL_REQUEST_FOR_UPDATING_RATE_LIMIT = `${BASE_ACTION_CONSTANT}/CANCEL_REQUEST_FOR_UPDATING_RATE_LIMIT`;

export const GET_RATE_LIMITS_METRICS_URL = {
  url: '/pg/api-metric/rate-limits',
  method: 'POST',
};

export const GET_RATE_LIMITS_GRAPH_DATA_URL = {
  url: '/pg/api-metric/rate-limits/graph',
  method: 'POST',
};

export const ADD_REQUEST_FOR_UPDATING_RATE_LIMIT_URL = {
  url: '/pg/rate-limit/request',
  method: 'POST',
};

export const CANCEL_REQUEST_FOR_UPDATING_RATE_LIMIT_URL = {
  url: '/pg/rate-limit/request/cancel',
  method: 'POST',
};

export const PATH_DROPDOWN_OPTIONS = [
  {
    key: '0',
    value: 'POST /orders',
    text: 'POST /orders',
    kongRouteName: 'pg_create-order',
  },
  {
    key: '1',
    value: 'GET /orders/:order_id',
    text: 'GET /orders/:order_id',
    kongRouteName: 'pg_get-order',
  },
  {
    key: '2',
    value: 'GET /orders/:order_id/payments',
    text: 'GET /orders/:order_id/payments',
    kongRouteName: 'pg_get-order-payments',
  },
  {
    key: '3',
    value: 'GET /orders/:order_id/payments/:payment_id',
    text: 'GET /orders/:order_id/payments/:payment_id',
    kongRouteName: 'pg_get-order-payment-by-id',
  },
  {
    key: '4',
    value: 'POST /orders/:order_id/refunds',
    text: 'POST /orders/:order_id/refunds',
    kongRouteName: 'pg_initiate-refund',
  },
  {
    key: '5',
    value: 'GET /orders/:order_id/refunds',
    text: 'GET /orders/:order_id/refunds',
    kongRouteName: 'pg_get-refunds',
  },
  {
    key: '6',
    value: 'GET /orders/:order_id/refunds/:refund_id',
    text: 'GET /orders/:order_id/refunds/:refund_id',
    kongRouteName: 'pg_get-refund',
  },
  {
    key: '7',
    value: 'GET /orders/:order_id/settlements',
    text: 'GET /orders/:order_id/settlements',
    kongRouteName: 'pg_get-order-settlement',
  },
  {
    key: '8',
    value: 'GET /links/:link_id',
    text: 'GET /links/:link_id',
    kongRouteName: 'pg_get-link',
  },
  {
    key: '9',
    value: 'POST /links/:link_id/cancel',
    text: 'POST /links/:link_id/cancel',
    kongRouteName: 'pg_cancel-link',
  },
  {
    key: '10',
    value: 'POST /links',
    text: 'POST /links',
    kongRouteName: 'pg_create-link',
  },
  {
    key: '11',
    value: 'GET /links/:link_id/orders',
    text: 'GET /links/:link_id/orders',
    kongRouteName: 'pg_get-link-orders',
  },
  {
    key: '12',
    value: 'GET /customers/:customer_id/instruments',
    text: 'GET /customers/:customer_id/instruments',
    kongRouteName: 'pg_get-customer-instruments',
  },
  {
    key: '13',
    value: 'GET /customers/:customer_id/instruments/:instrument_id',
    text: 'GET /customers/:customer_id/instruments/:instrument_id',
    kongRouteName: 'pg_get-customer-instruments-by-id',
  },
  {
    key: '14',
    value: 'DELETE /customers/:customer_id/instruments/:instrument_id',
    text: 'DELETE /customers/:customer_id/instruments/:instrument_id',
    kongRouteName: 'pg_deactivate-customer-instruments-by-id',
  },
  {
    key: '15',
    value: 'GET /customers/:customer_id/instruments/:instrument_id/cryptogram',
    text: 'GET /customers/:customer_id/instruments/:instrument_id/cryptogram',
    kongRouteName: 'pg_get-cryptogram-instruments-by-id',
  },
  {
    key: '16',
    value: 'POST /orders/:order_id/authorization',
    text: 'POST /orders/:order_id/authorization',
    kongRouteName: 'pg_authorize-payment',
  },
  {
    key: '17',
    value: 'POST /orders/:order_id/cart',
    text: 'POST /orders/:order_id/cart',
    kongRouteName: 'pg_create-checkout-cart',
  },
  {
    key: '18',
    value: 'GET /orders/:order_id/cart',
    text: 'GET /orders/:order_id/cart',
    kongRouteName: 'pg_get-checkout-cart',
  },
  {
    key: '19',
    value: 'POST /custom/reports',
    text: 'POST /custom/reports',
    kongRouteName: 'pg_get-report-stream',
  },
  {
    key: '20',
    value:'POST /subscriptions',
    text:'POST /subscriptions',
    kongRouteName: 'pg_subscription_create_subscription'
  },
  {
    key: '21',
    value:'GET /subscriptions/:subscription_id',
    text:'GET /subscriptions/:subscription_id',
    kongRouteName: 'pg_subscription_get_subscription'
  },
  {
    key: '22',
    value:'POST /subscriptions/pay',
    text:'POST /subscriptions/pay',
    kongRouteName: 'pg_subscription_create_payment'
  },
];

export const METRIC_TYPE = {
  REQUEST_COUNT: 'REQUEST_COUNT_GRAPH',
  RATE_LIMIT_VIOLATIONS: 'RATE_LIMIT_VIOLATIONS_GRAPH',
};

export const GRAPH_TIME_OPTIONS = [
  {
    key: '24h',
    text: '24 hours',
    range: [
      moment()
        .subtract(24, 'hours')
        .toDate(),
      moment().toDate(),
    ],
  },
  {
    key: '4h',
    text: '4 hours',
    range: [
      moment()
        .subtract(4, 'hours')
        .toDate(),
      moment().toDate(),
    ],
  },
];

export const PAGINATION_PAGE_SIZE_OPTIONS = [
  { key: '0', value: '10', text: '10' },
  { key: '1', value: '25', text: '25' },
];

export const HEADINGS = [
  {
    key: 'api',
    displayName: 'API',
    width: 0.8,
  },
  {
    key: 'totalLimit',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>
          Total Limit{'\n'}
          (per min.)
        </Text>
        <Popup
          content={
            <Text color="bodyLight">Sum of standard and burst limits</Text>
          }
          trigger={
            <span>
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    infoPopup: 'Sum of standard and burst limits',
    width: 0.1,
    align: 'center',
  },
  {
    key: 'rateLimit',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>
          Rate Limit{'\n'}
          (per min.)
        </Text>
        <Popup
          content={
            <Text color="bodyLight">
              Standard number of requests permitted per minute
            </Text>
          }
          trigger={
            <span>
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    width: 0.1,
    align: 'center',
  },
  {
    key: 'burstLimit',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>Burst Limit</Text>
        <Popup
          content={
            <Text color="bodyLight">
              Extra number of requests permitted for specified duration
            </Text>
          }
          trigger={
            <span>
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    width: 0.1,
    align: 'center',
  },
  {
    key: 'violationCount',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>
          Violation Count{`\n`}
          (last 12 hrs)
        </Text>
        <Popup
          content={
            <Text color="bodyLight">
              Number of requests exceeding the total limit in the past 12 hours,
            </Text>
          }
          trigger={
            <span>
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    width: 0.1,
    align: 'center',
  },
  {
    key: 'latestUsage',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>
          Latest Usage{`\n`}
          (last 4 hrs)
        </Text>
        <Popup
          content={
            <Text color="bodyLight">
              Percentage of total limit used, averaged over 4 hours,
            </Text>
          }
          trigger={
            <span>
              {' '}
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    width: 0.1,
    align: 'center',
  },
  {
    key: 'averageUsage',
    displayName: (
      <Space
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Text>
          Average Usage{`\n`}
          (last 24 hrs)
        </Text>
        <Popup
          content={
            <Text color="bodyLight">
              Percentage of total limit used, averaged over 24 hours
            </Text>
          }
          trigger={
            <span>
              <CustomIcons
                componentName="INFO"
                fill="#2B2D42"
                className="mr-left-7"
              />
            </span>
          }
        />
      </Space>
    ),
    width: 0.2,
    align: 'right',
  },
  {
    key: 'requestNewLimit',
    displayName: '',
    width: 0.16,
    align: 'right',
  },
];

export const RATE_LIMIT_TYPE = 'RATE_LIMIT';

export const BURST_LIMIT_TYPE = 'BURST_LIMIT';

export const RATE_LIMIT_REQUEST_TYPE = [
  {
    value: RATE_LIMIT_TYPE,
    label: 'Request Rate Limit',
    description:
      'Rate Limit is used to control the rate at which requests are made to a network.',
  },
  {
    value: BURST_LIMIT_TYPE,
    label: 'Request Burst Limit',
    description:
      'Burst limit is the maximum short-term traffic volume the system will handle within one interval',
  },
];

export const NO_DATA = '-';
